// extracted by mini-css-extract-plugin
export default {"payments_header":"PaymentsTable_payments_header__j7TWj","practice_amount":"PaymentsTable_practice_amount__NNAZJ"};